import { FilterValue } from "../Filters/FilterValue";

export const PaymentStatuses: FilterValue[] = [
  { id: "1", value: "Paid" },
  { id: "2", value: "Pending" },
  { id: "3", value: "Unpaid" },
];
